import { SizeProp } from "@fortawesome/fontawesome-svg-core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "../../utils/icons";
import { CSSProperties, MouseEventHandler } from "react";

interface IProps {
  name: string;
  size?: SizeProp;
  className?: string;
  canRotate?: boolean;
  isLoading?: boolean;
  onClick?: MouseEventHandler<SVGSVGElement>;
}
function Icon(props: IProps) {
  const { name, size, className, isLoading } = props;
  const iconSize: SizeProp = "sm";

  function render() {
    return (
      <FontAwesomeIcon
        className={className ? className : "text-primary"}
        icon={icons[name]}
        size={size ? size : iconSize}
        spin={isLoading}
        style={{ "--fa-animation-duration": "0.2s" } as CSSProperties}
        onClick={event => {
          if (props.onClick) {
            props.onClick(event);
          }
        }}
      />
    );
  }
  return render();
}

export default Icon;
